export function ensureHttpUrl(rawUrl) {
    const trimmed = rawUrl.trim();
    if (/^https?:\/\//i.test(trimmed))
        return trimmed;
    return `https://${trimmed}`;
}
export function parseHostname(rawUrl) {
    if (!rawUrl)
        return null;
    try {
        return new URL(ensureHttpUrl(rawUrl)).hostname.replace(/^www\./, '');
    }
    catch {
        return null;
    }
}
export function faviconUrl(rawUrl) {
    const host = parseHostname(rawUrl);
    return host ? `https://icons.duckduckgo.com/ip3/${host}.ico` : null;
}
//# sourceMappingURL=url-utils.js.map